import { j as o } from "./index.es33.js";
import { Icon as t } from "./index.es7.js";
import { Typography as c } from "./index.es35.js";
import { palette as i } from "./index.es36.js";
import { InlineMessageType as n } from "./index.es183.js";
import { INLINE_MESSAGE_TYPES_MAP as s } from "./index.es184.js";
import m from "./index.es185.js";
var a = function a(_ref) {
  var r = _ref.type,
    e = _ref.onClick,
    l = _ref.children;
  return o.jsxs("div", {
    className: m.message,
    style: {
      backgroundColor: s[r].color,
      borderColor: s[r].borderColor
    },
    children: [s[r].icon, o.jsx(c.Body2, {
      color: i.gray10,
      children: l
    }), e && o.jsx("button", {
      className: m.close,
      type: "button",
      onClick: e,
      children: o.jsx(t, {
        icon: t.icons.system.s.utilities.cross,
        size: 16,
        color: i.gray6
      })
    })]
  });
};
a.type = n;
export { a as InlineMessage };